import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { VariantProps } from 'cva'
import { cva, cx } from 'cva'
import type { FC } from 'react'
import type { ButtonProps } from './Button'

export const buttonToggleVariants = cva({
	base: 'group flex items-center justify-center font-semibold rounded-md w-fit cursor-pointer pointer-events-auto border-(length:--stroke-sm) text-h6 py-2 whitespace-nowrap',
	variants: {
		active: {
			true: 'bg-blue-shade-70 text-white border-blue-shade-70',
			false:
				'bg-white text-blue border-blue hover:bg-blue-tint-10 active:bg-blue-shade-70 active:text-white active:border-blue-shade-70',
		},
		hasIcon: {
			true: 'gap-x-xs pl-3.5 pr-3',
			false: 'px-3.5',
		},
	},
	defaultVariants: {
		active: false,
		hasIcon: false,
	},
})

export type ButtonToggleVariants = VariantProps<typeof buttonToggleVariants>

export type ButtonToggleProps = Omit<ButtonToggleVariants, 'hasIcon'> &
	Pick<ButtonProps, 'title' | 'label' | 'onClick'>

export const ButtonToggle: FC<ButtonToggleProps> = ({ label, active, title, ...props }) => {
	return (
		<button
			{...props}
			title={title || label}
			className={buttonToggleVariants({ active, hasIcon: true })}
		>
			<span>{label}</span>
			<FontAwesomeIcon
				icon={['fas', 'plus']}
				size="sm"
				className={cx(
					'transition-transform duration-150 ease-in-out',
					active && 'rotate-45 text-blue group-hover:text-white',
				)}
			/>
		</button>
	)
}
